<template>
    <!-- Top Bar Start -->
    <div class="topbar">
        <!-- LOGO -->
        <div class="topbar-left d-none d-sm-none d-md-block  ">
            <a href="#" class="logo">
                <span> <img src="./assets/logo_white.svg" alt="" height="18"> </span>

            </a>
        </div>

        <nav class="navbar-custom">
            <ul class="list-inline float-right mb-0">
                <li class="list-inline-item dropdown">
                    <a class="nav-link dropdown-toggle arrow-none " data-toggle="dropdown" href="#" role="button"
                       aria-haspopup="false" aria-expanded="false">
                        FAQs
                    </a>
                    <div class="dropdown-menu dropdown-menu-right dropdown-arrow">
                        <router-link :to="{name:'price_table'}" class="dropdown-item ">
                            Price Table
                        </router-link>
                    </div>
                </li>



                <li class="list-inline-item dropdown notification-list">
                    <a class="nav-link dropdown-toggle nav-user" data-toggle="dropdown" href="#" role="button"
                       aria-haspopup="false" aria-expanded="false">
                        <img :src="'https://avatars.dicebear.com/v2/avataaars/'+$author.name()+'-1.svg'" alt="user"
                             class="rounded-circle img-thumbnail"> {{ $author.name() }}
                    </a>
                    <div class="dropdown-menu dropdown-menu-right profile-dropdown " aria-labelledby="Preview">
                        <div class="avatar p-3 pt-1 text-center">
                            <img :src="'https://avatars.dicebear.com/v2/avataaars/'+$author.name()+'-1.svg'"
                                 class="img-thumbnail rounded-circle" alt="">
                            <small> {{ $author.name() }} <br>
                                {{ $author.email() }}
                            </small>
                        </div>

                        <!-- item-->
                        <div class="text-right p-1">
                            <router-link to="logout" class="btn btn-primary">
                                <span>Logout</span>
                            </router-link>
                        </div>
                    </div>
                </li>
            </ul>
            <ul class="list-inline menu-left mb-0">
                <li class="float-left d-block d-sm-none">
                    <button class="text-nowrap button-menu-mobile open-left" @click="this.$bus.toggleSidebar">
                        <i class="fi-menu"/>
                    </button>
                </li>
                <li class="d-none d-md-block app-search">
                    <input v-model="keyword" type="search" placeholder="Search..." class="form-control"
                           @keypress.enter="search">
                </li>
            </ul>
        </nav>
    </div>
    <!-- Top Bar End -->
</template>

<script>
    export default {
        name: "TopBar",
        data: function () {
            return {
                keyword: ''
            }
        },
        mounted: function () {
            this.keyword = this.$route.query.keyword
        },
        methods: {
            search: function () {
                this.$router.push({name: 'campaign', query: {keyword: this.keyword}})
            }
        }

    }
</script>

<style scoped>

</style>